import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import PopupSearch from "../components/PopupSearch";
import ScrollToTop from "../components/ScrollToTop";

const Contact: React.FC = () => {
   const [menuOpen, setMenuOpen] =  useState(false);
  return (
    <>
      <MobileMenu
  isOpen={menuOpen}
  onClose={() => setMenuOpen(false)}
/>
      <PopupSearch />

      <main className="main">
        <Header />

        {/* Breadcrumb Section */}
        <div
          className="breadcumb-wrapper"
          style={{
            backgroundImage: "url('/assets/img/bg/breadcumb-bg-4.jpg')",
                 backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
          }}
        >
          <img
            src="/assets/img/shapes/dot-shape.svg"
            alt="dot"
            className="breadcumb-element"
          />

          <div className="container z-index-common">
            <div className="breadcumb-content">
              <h1 className="breadcumb-title">Contact Us</h1>

              <div className="breadcumb-menu-wrap">
                <ul className="breadcumb-menu">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>Contact Us</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Section */}
        <section className="space space-extra-bottom faq-main-section">
          <div className="container">
            <div className="row gx-60 align-items-center">
              
              {/* Left Contact Info */}
              <div className="col-lg-5 mb-30">
                <div className="mb-30">
                  <span className="sec-subtitle">contact info</span>
                  <h2 className="sec-title text-white">get in touch</h2>

                  <img
                    src="/assets/img/shapes/title-shape-1.svg"
                    alt="title shape"
                  />
                </div>

                <div className="contact-info mb-20">
                  <span>Address:</span> India
                </div>

                <div className="mb-20">
                  <span className="address-info">
                  <i className="fa-solid fa-phone-volume"></i>
                    Phone:
                    <a href="tel:+918928218258"> (+91) 89282 18258</a>
                  </span>

                  <span className="address-info">
             <i className="fa-solid fa-envelope"></i>
                    Email:
                    <a href="mailto:Ninesisters0819@gmail.com">
                      {" "}
                      Ninesisters0819@gmail.com
                    </a>
                  </span>
                </div>

                {/* Social Links */}
                {/* <div className="social-style">
                  <h4 className="footer-title mb-0">follow</h4>

                  <a className="facebook" href="#">
                    <i className="fab fa-facebook-f"></i>
                  </a>

                  <a className="instagram" href="#">
                    <i className="fab fa-instagram"></i>
                  </a>

                  <a className="twitter" href="#">
                    <i className="fab fa-twitter"></i>
                  </a>

                  <a className="linkedin" href="#">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </div> */}
              </div>

              {/* Contact Form */}
              <div className="col-lg-7 mb-30">
                <form className="form-style2">
                  <div className="row gx-20">
                    <div className="col-md-6 form-group">
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Your Name *"
                      />
                    </div>

                    <div className="col-md-6 form-group">
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Last Name *"
                      />
                    </div>

                    <div className="col-md-6 form-group">
                      <input
                        className="form-control"
                        type="email"
                        placeholder="Email Address"
                      />
                    </div>

                    <div className="col-md-6 form-group">
                      <input
                        className="form-control"
                        type="tel"
                        placeholder="Phone *"
                      />
                    </div>

                    <div className="col-12 form-group">
                      <textarea
                        className="form-control"
                        placeholder="Type Your Message"
                      ></textarea>
                    </div>

                    <div className="col-12">
                      <button type="submit" className="vs-btn">
                        submit now
                      </button>
                    </div>
                  </div>
                </form>

                <p className="form-messages mb-0 mt-3"></p>
              </div>
            </div>
          </div>
        </section>

        {/* Google Map Section */}
        <div className="space-bottom faq-main-section">
          <div className="container">
            <div className="map-style1">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7416.874055413248!2d85.00373!3d24.796069!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f32a0c3d3d3d3d%3A0x1!2sGaya%2C%20Bihar%2C%20India!5e0!3m2!1sen!2sin!4v1693456840610!5m2!1sen!2sin"
                width="100%"
                height="450"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Google Map"
              ></iframe>
            </div>
          </div>
        </div>

        <Footer />
      </main>

      <ScrollToTop />
    </>
  );
};

export default Contact;